<template>
  <div class="index-outer">
    <myheader :show="false"></myheader>
    <div class="login PcStyle">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
      >
        <h1 class="Btitle">欢迎登录</h1>
        <h4 class="Stitle">钱学森图书馆团队参观申请系统</h4>
        <el-form-item prop="mail">
          <el-input
            v-model="loginForm.mail"
            type="text"
            prefix-icon="el-icon-message"
            auto-complete="off"
            placeholder="请输入你的邮箱"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="loginForm.code"
            auto-complete="off"
            prefix-icon="el-icon-chat-line-round"
            placeholder="请输入邮箱验证码"
            style="width: 63%"
            @keyup.enter.native="handleLogin"
          >
          </el-input>
          <div v-if="numbershow" class="login-code" @click="getCode">
            <div>获取验证码</div>
          </div>
          <div class="login-code" v-else>
            <div>{{ number }}</div>
          </div>
        </el-form-item>
        <el-form-item prop="sjcode">
        <el-input
          v-model="loginForm.sjcode"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon
            slot="prefix"
            icon-class="validCode"
            class="el-input__icon input-icon"
          />
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getsjCode" class="login-code-img" />
        </div>
      </el-form-item>

        <el-form-item style="width: 100%" @click.native.prevent="handleLogin">
          <div class="sumbit" style="width: 100%">立即登录</div>
        </el-form-item>
        <el-form-item label="" >
          <div class="tishi">
            无法使用在线报名系统的特殊群体，钱学森图书馆开通电话预约具体方式如下：
          </div>
        </el-form-item>
        <el-form-item label="" >
          <div class="tishi">
1、提前7-14个自然日致电021-62932068（在岗时间：周二至周日 9:00—16:30），由馆方工作人员登记团队信息及需求（如参观日期、人数、是否需要讲解等）；
</div>       
</el-form-item>
        <el-form-item label="" >
          <div class="tishi">
2、工作人员将于登记之日始5个工作日内回电确认，经馆方确认后方认定报名成功。</div>

        </el-form-item>
      </el-form>
    </div>

    <div class="el-login-footer">
      <span>Copyright © 2023 groupqxslib.situ.edu.cn All Rights Reserved. 备案号"沪交CP备20230157"</span>
    </div>
  </div>
</template>
<script>
import myheader from "../components/myheader.vue";
import { setPToken, getPToken } from "../token";
export default {
  name: "Login",
  data() {
    return {
      codeUrl: "",
      timer: null,
      numbershow: true,
      number: 120,
      loginForm: {
        mail: "",
        code: "",
      },
      loginRules: {
        mail: [
          { required: true, trigger: "blur", message: "邮箱不能为空" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        code: [
          { required: true, trigger: "change", message: "邮箱验证码不能为空" },
        ],
      },
      loginShow: true,
    };
  },
  watch: {},
  components: {
    myheader,
  },
  created() {
    this.getsjCode();
    if (getPToken()) {
      this.$router.push("/ptype");
    }
  },
  methods: {
    getsjCode() {
      this.$axios("/captchaImage").then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    handleLogin() {
      if (this.loginShow) {
        this.$refs["loginForm"].validate((valid) => {
          if (valid) {
            this.loginShow = false;
            this.$axios
              .get("/login/mailLogin?mail="+this.loginForm.mail+"&code="+this.loginForm.code+"&uuid="+this.loginForm.uuid+"&sjcode="+this.loginForm.sjcode)
              .then((res) => {
                this.loginShow = true;
                if (res.code == 200) {
                  setPToken(res.data);
                  this.$router.push("/ptype");
                } else {
                  this.$message.error(res.msg);
                }
              });
          }
        });
      } else {
        console.log("请勿重复提交信息");
      }
    },
    getCode() {
      if (this.loginForm.mail) {
        this.setNumber();
        this.$axios("/login/mail?mail=" + this.loginForm.mail).then((res) => {
          if (res.code == 200) {
            this.$message.success("验证码发送成功");
          } else {
            this.$message.error("验证码发送失败");
          }
        });
      }
    },
    setNumber() {
      this.numbershow = false;
      this.timer = setInterval(() => {
        if (this.number != 0) {
          this.number = this.number - 1;
        } else {
          this.numbershow = true;
          clearInterval(this.timer);
          this.timer = null;
          this.number = 60;
        }
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    this.number = 60;
  },
};
</script>
  
<style  lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
.Btitle {
  color: #aa2020;
}
.Stitle {
  color: #0000006a;
  margin-bottom: 30px;
}
.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 450px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  cursor: pointer;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
  div {
    width: 100%;
    background-color: rgb(170, 32, 32);
    color: #ffffff;
    text-align: center;
    border-radius: 10px;
  }
}

.el-login-footer {
  height: 57px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}.sumbit {
  //     position: absolute;
  // width: 538px;
  // height: 59px;
  // top: 714px;
  // left: 452px;

  background: rgb(170, 32, 32);
  border-radius: 7px;
  color: #ffffff;
  text-align: center;
}
.login-code-img {
  height: 38px;
}
.tishi{
  line-height: 15px !important ;
font-size: 12px  !important ;
}

</style>
  